import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalPoliciesRoute: InvariantJiraRoute = {
	name: 'eoc-policies',
	path: '/jira/settings/products/ops/policies',
	exact: true,
};
